import Loading from "components/loading/Loading";
import { getProfileClinic } from "helpers/api/profile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUserInfo, showToastError } from "utils";
import "./styles.scss";

export const USPV011 = () => {
  const { t } = useTranslation();
  const userInfo = getUserInfo();
  const [loading, setLoading] = useState(0);
  const [clinicInfo, setClinicInfo] = useState();

  const getClinicProfile = () => {
    setLoading((prev) => prev + 1);
    getProfileClinic()
      .then((res) => {
        setClinicInfo(res.data);
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  useEffect(() => {
    getClinicProfile();
  }, []);

  return (
    <div className="main-content help-container">
      <div className="root-right-header">
        <div className="screen-name">{userInfo.clinic_name + " " + t("prefix")}</div>
      </div>
      <div className="bg-white">
        <div className="clinic-code-container">
          <div className="document-title">
            {userInfo.clinic_name + t("clinicCode.clinicCode")}
          </div>
          <div className="document-value">{userInfo?.clinic_code}</div>
          <div className="document-link-row">
            <img
              src="/icons/document.webp"
              className="document-icon"
              alt="img-document"
            />
            <a className="document-text" href={clinicInfo?.clinic_url_pdf}>
              {t("clinicCode.docsPdf")}
            </a>
          </div>
          <div className="document-notice">
            {t("clinicCode.doc_description")}
          </div>
        </div>
      </div>
      {loading && <Loading />}
    </div>
  );
};
